import { CalculationMetricTable } from 'modules/components/layer25';



export type DebugDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DebugDetailSectionProps) => {
  return (
    <CalculationMetricTable.FC showChatBubble />
  );
};
